import React, { memo } from "react";
import cn from "classnames";
import styles from "./machines-list-with-companies.modules.scss";
import { useI18N } from "@src/language/language-context";
import arrow from "@src/assets/svg/arrow.svg";
import { MachinesList } from "../machines-list/machines-list";
import { transformedGatewaysWithMachinesListEntryTypes } from "@common/types/machines-list-types";

const cssClassName = "machines-list-with-companies";

interface MachinesListWithCompaniesPropsTypes {
  companyData: transformedGatewaysWithMachinesListEntryTypes;
  isCompanyExpanded: boolean;
  handleCompanyToggle: () => void;
  selectedSourceId?: string;
}

export const MachinesListWithCompanies = memo(
  ({
    companyData,
    isCompanyExpanded,
    handleCompanyToggle,
    selectedSourceId,
  }: MachinesListWithCompaniesPropsTypes) => {
    const i18n = useI18N();

    const allMachinesByCompany = Object.values(companyData?.sources ?? {});
    const machinesByCompanyCount = allMachinesByCompany.length;

    const texts = {
      machine: i18n("modules.machinesListWithCompanies.machine"),
      machines: i18n("modules.machinesListWithCompanies.machines"),
      gateWayIcon: i18n("modules.machinesListWithCompanies.gateWayIcon"),
      machinesListEmptyInfoText: i18n(
        "modules.machinesListWithCompanies.machinesListEmptyInfoText",
      ),
    };

    return (
      <>
        <div
          className={cn(styles[`${cssClassName}__header-row`], {
            [styles[`${cssClassName}__header-row--opened`]]: isCompanyExpanded,
          })}
          role="button"
          tabIndex={0}
          onClick={() => handleCompanyToggle?.()}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleCompanyToggle?.();
            }
          }}
        >
          <div className={styles[`${cssClassName}__header-container`]}>
            <span className={styles[`${cssClassName}__header-content`]}>
              <span className={styles[`${cssClassName}__company-name`]}>
                {companyData.name}
              </span>

              <span className={styles[`${cssClassName}__count`]}>
                {machinesByCompanyCount}{" "}
                {machinesByCompanyCount === 1 ? texts.machine : texts.machines}
              </span>

              <img
                src={arrow}
                alt={texts.gateWayIcon}
                className={cn(styles[`${cssClassName}__gateway-icon`], {
                  [styles[`${cssClassName}__gateway-icon--rotate`]]:
                    isCompanyExpanded,
                  [styles[`${cssClassName}__gateway-icon--rotate-back`]]:
                    !isCompanyExpanded,
                })}
              />
            </span>
          </div>
        </div>
        {isCompanyExpanded && (
          <div className={styles[`${cssClassName}__content`]}>
            {allMachinesByCompany.length === 0 ? (
              <p className={styles[`${cssClassName}__empty-message`]}>
                {texts.machinesListEmptyInfoText}
              </p>
            ) : (
              <MachinesList
                allMachinesByCompany={allMachinesByCompany}
                selectedSourceId={selectedSourceId}
              />
            )}
          </div>
        )}
      </>
    );
  },
);

MachinesListWithCompanies.displayName = "MachinesListWithCompanies";
